import { memo, useCallback } from 'react';
import { MenuTrigger } from 'react-aria-components';

import { Button, Menu, MenuItem, Popover, Text } from '@/components/core';
import { EditIcon, OverflowIcon } from '@/components/icons';
import { useDocumentStore } from '@/store';

import { ExportMenuItems } from './ExportMenuItems';

export type DocumentFormOverflowMenuProps = {
  agentId?: string | null;
  runIds?: string[] | null;
};

const IDocumentFormOverflowMenu = ({ agentId, runIds }: DocumentFormOverflowMenuProps) => {
  const isEditing = useDocumentStore((state) => state.isEditing);
  const setIsEditing = useDocumentStore((state) => state.setIsEditing);
  const setFocusedField = useDocumentStore((state) => state.setFocusedField);

  const doneEditing = useCallback(() => {
    setIsEditing(false);
    setFocusedField(undefined);
  }, [setFocusedField, setIsEditing]);

  return (
    <MenuTrigger>
      <Button variant="plain">
        <OverflowIcon />
      </Button>

      <Popover placement="top">
        <Menu>
          {isEditing ? (
            <MenuItem onAction={doneEditing}>
              <EditIcon />
              <Text>Done editing values</Text>
            </MenuItem>
          ) : (
            <MenuItem onAction={() => setIsEditing?.(true)}>
              <EditIcon />
              <Text>Edit values</Text>
            </MenuItem>
          )}
          <ExportMenuItems agentId={agentId} runIds={runIds} />
        </Menu>
      </Popover>
    </MenuTrigger>
  );
};

export const DocumentFormOverflowMenu = memo(IDocumentFormOverflowMenu) as typeof IDocumentFormOverflowMenu;
